import { WrapperWidget } from '@agentselly/ui';
import { EmptyState } from '~/components/empty/EmptyState';
import { AppLink } from '~/components/AppLink';
import { T } from '@tolgee/react';
import { Button } from '~/components/ui/Button';

interface Props {
  readonly link: string;
  readonly isSeller: boolean;
  readonly showDemoWidgetContent?: boolean;
}

export function NewPropertyWidget(props: Props) {
  if (!props.showDemoWidgetContent) {
    const translationSuffix = props.isSeller ? '_seller' : '_buyer';
    return (
      <WrapperWidget>
        <EmptyState
          title={
            <T
              keyName={`evaluation_new_property_widget_title${translationSuffix}`}
            />
          }
          description={
            <T
              keyName={`evaluation_new_property_widget_text${translationSuffix}`}
            />
          }
        />
      </WrapperWidget>
    );
  }

  const translationSuffix = props.isSeller ? '_seller' : '_buyer';

  return (
    <WrapperWidget>
      <div className="h-full flex flex-col gap-y-6">
        <h2 className="text-lg font-bold">
          <T
            keyName={`evaluation_new_property_widget_title${translationSuffix}`}
          />
        </h2>

        <p className="whitespace-pre-wrap">
          <T
            keyName={`evaluation_new_property_widget_text${translationSuffix}`}
          />
        </p>

        <AppLink
          to={props.link}
          className="self-start"
        >
          <Button
            primary
            showArrow
          >
            <T>evaluation_new_property_widget_button_text</T>
          </Button>
        </AppLink>
      </div>
    </WrapperWidget>
  );
}
